import {
  Button,
  ButtonGroup,
  Checkbox,
  Popover,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { FilterTag } from "./FilterTag";
import { useStores } from "../../../../shared/stores/RootStore";
import { CustomPopover } from "../../../../shared/views/CustomPopover";
import { AddFilterButton } from "./AddFilterButton";

const OsaWayFiltersBase: React.FC = () => {
  const { filterStore, osaWayStore } = useStores();
  const { open, onToggle, onClose } = useDisclosure();
  const [selectedIds, setSelectedIds] = useState(new Set<string>());

  useEffect(() => {
    if (open) {
      setSelectedIds(() => new Set(filterStore.osaWayFilters));
    }
    //eslint-disable-next-line
  }, [open]);

  const handleClear = () => {
    setSelectedIds(new Set());
  };

  const handleSubmit = () => {
    filterStore.setOsaWayFilters([...selectedIds]);
    onClose();
  };

  const removeActiveFilter = (osaWayId: string) => {
    filterStore.setOsaWayFilters(
      filterStore.osaWayFilters.filter((item) => item !== osaWayId),
    );
  };

  return (
    <>
      <CustomPopover
        open={open}
        onClose={onClose}
        asChild={false}
        trigger={<AddFilterButton label="Route" onClick={onToggle} />}
      >
        <Popover.Header fontWeight={"semibold"}>
          {t("map:filters.byRouteTitle")}
        </Popover.Header>
        <Popover.Body maxH="360px" overflowY="auto">
          <VStack alignItems="start">
            {filterStore.osaWaysAvailableToUser.map((way, i) => (
              <Checkbox.Root
                key={i}
                colorPalette="primary"
                name={way.id}
                checked={selectedIds.has(way.id)}
                onCheckedChange={({ checked }) => {
                  setSelectedIds((prev) => {
                    if (checked) {
                      prev.add(way.id);
                    } else {
                      prev.delete(way.id);
                    }
                    return new Set(prev);
                  });
                }}
              >
                <Checkbox.HiddenInput />
                <Checkbox.Control />
                <Checkbox.Label>
                  <Text fontSize="sm" lineClamp={1}>
                    {way.name}
                  </Text>
                </Checkbox.Label>
              </Checkbox.Root>
            ))}
          </VStack>
        </Popover.Body>
        <Popover.Footer display="flex" justifyContent="flex-end">
          <ButtonGroup colorPalette="primary" size="sm">
            <Button onClick={handleClear} disabled={!selectedIds.size}>
              {t("map:filters.clearButton")}
            </Button>
            <Button onClick={handleSubmit}>
              {t("map:filters.submitButton")}
            </Button>
          </ButtonGroup>
        </Popover.Footer>
      </CustomPopover>

      {!!filterStore.osaWayFilters.length &&
        filterStore.osaWayFilters.map((osaWayId, i) => (
          <FilterTag key={i} onClose={() => removeActiveFilter(osaWayId)}>
            {osaWayStore.get(osaWayId)?.name}
          </FilterTag>
        ))}
    </>
  );
};

export const OsaWayFilters = observer(OsaWayFiltersBase);
